import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isNavigation", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef } from 'react';
import { View } from "../../../layout";
import { jsx as ___EmotionJSX } from "@emotion/core";
var NavWrapper = View.withComponent('nav', {
  target: "e7to1580"
});
export var OptionalNavWrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isNavigation = _ref.isNavigation,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var sharedProps = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref
  });

  if (isNavigation) {
    return ___EmotionJSX(NavWrapper, sharedProps, children);
  }

  return ___EmotionJSX(View, sharedProps, children);
});